module.exports = __webpack_public_path__ + "media/images/pro-dbf9cdd90db92186af9d387cebb57444.svg";